import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import { mapState } from 'vuex';
export default {
  name: 'ChartCustomOptionsEditor',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled'])
  },
  methods: {
    getByKey(key, defaultValue = undefined) {
      return get(this.value, key, defaultValue);
    },
    setByKey(key, value) {
      const clone = cloneDeep(this.value);
      set(clone, key, value);
      this.$emit('input', clone);
    }
  }
};